import { render, staticRenderFns } from "./StatisticsChart.vue?vue&type=template&id=2ad9b9a3&scoped=true&"
import script from "./StatisticsChart.vue?vue&type=script&lang=js&"
export * from "./StatisticsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad9b9a3",
  null
  
)

/* custom blocks */
import block0 from "./StatisticsChart.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports